package feature.mediaFile.network

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class MediaFileRetrieveRequest(
    @SerialName("BusinessID") val businessID: String,
    @SerialName("FeatureObjectID") val featureObjectID: String? = null,
)